import {
  eachMonthOfInterval,
  eachQuarterOfInterval,
  endOfYear,
  isWithinInterval,
  startOfYear,
  subMinutes,
  subYears,
} from 'date-fns';
import { Maybe } from 'generated/graphql';
import { t } from 'i18next';

export const getAvailableMonths = (
  marketingStart: Maybe<Date> | undefined,
  marketingEnd: Maybe<Date> | undefined,
  name: string,
) =>
  eachMonthOfInterval({
    start: marketingStart ?? startOfYear(subYears(new Date(), 1)),
    // We subtract 1 minute because the marketing-end-date is usually set on midnight of the next day
    end: (marketingEnd && subMinutes(marketingEnd, 1)) ?? new Date(),
  })
    .map((date) => ({
      id: date.toISOString(),
      date,
      name: t(name, { date }),
    }))
    .filter((month) =>
      isWithinInterval(month.date, {
        start: startOfYear(subYears(new Date(), 1)),
        end: endOfYear(new Date()),
      }),
    );

export const getAvailableQuarters = (
  marketingStart: Maybe<Date> | undefined,
  marketingEnd: Maybe<Date> | undefined,
  name: string,
) =>
  eachQuarterOfInterval({
    start: marketingStart ?? startOfYear(subYears(new Date(), 1)),
    end: (marketingEnd && subMinutes(marketingEnd, 1)) ?? new Date(),
  })
    .map((date) => ({
      id: date.toISOString(),
      date,
      name: t(name, { date }),
    }))
    .filter((quarter) =>
      isWithinInterval(quarter.date, {
        start: startOfYear(subYears(new Date(), 1)),
        end: endOfYear(new Date()),
      }),
    );
